var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H6C4.34315 18 3 16.6569 3 15V5C3 3.34315 4.34315 2 6 2H13C14.6569 2 16 3.34315 16 5V7.5M12.5 12.5V11.5C12.5 10.6716 13.1716 10 14 10C14.8284 10 15.5 10.6716 15.5 11.5V13M12.5 6H6M9.5 9H6M8 12H6M12 18H16C16.5523 18 17 17.5523 17 17V14C17 13.4477 16.5523 13 16 13H12C11.4477 13 11 13.4477 11 14V17C11 17.5523 11.4477 18 12 18Z",
    stroke: "#102039",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicy);
export default __webpack_public_path__ + "static/media/PrivacyPolicy.530f371f1416d50b93b73f6c687c3d29.svg";
export { ForwardRef as ReactComponent };